import { DIFFICULTY_LEVELS, QUESTION_TYPES } from '../questionTypes';

// 30 Preguntas del Músculo Cuádriceps Femoral
// 10 Básicas + 10 Generales + 10 Complejas

export const cuadricepsFemoralQuestions = [
  
  // ========== NIVEL BÁSICO (10) ==========
  
  {
    id: 10091,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Cuántos músculos componen el cuádriceps femoral?",
    options: ["Dos", "Tres", "Cuatro", "Cinco"],
    correctAnswer: 2,
    explanation: "El cuádriceps femoral está compuesto por cuatro músculos: recto femoral (anterior), vasto medial (interno), vasto lateral (externo) y vasto intermedio (profundo). Todos convergen en un tendón común que se inserta en la tuberosidad tibial a través del ligamento rotuliano."
  },
  
  {
    id: 10092,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Dónde se inserta el tendón del cuádriceps femoral?",
    options: [
      "Cóndilos femorales",
      "Tuberosidad tibial",
      "Cabeza de la fíbula",
      "Cóndilos tibiales"
    ],
    correctAnswer: 1,
    explanation: "El cuádriceps femoral se inserta en la tuberosidad tibial a través del ligamento rotuliano (tendón rotuliano). Esta inserción distal permite la extensión de la rodilla, siendo el principal extensor de la articulación tibiofemoral."
  },
  
  {
    id: 10093,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Cuál es la acción principal del cuádriceps femoral?",
    options: [
      "Flexión de la rodilla",
      "Extensión de la rodilla",
      "Rotación interna de la tibia",
      "Abducción del muslo"
    ],
    correctAnswer: 1,
    explanation: "La acción principal del cuádriceps femoral es la extensión de la rodilla. Es el músculo más potente del cuerpo humano y esencial para la marcha, carrera, salto y mantenimiento de la posición erecta. Su fuerza es crucial para la estabilidad de la rodilla."
  },
  
  {
    id: 10094,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.INERVACION,
    question: "¿Qué nervio inerva al cuádriceps femoral?",
    options: [
      "Nervio femoral",
      "Nervio ciático",
      "Nervio tibial",
      "Nervio peroneo común"
    ],
    correctAnswer: 0,
    explanation: "El nervio femoral (L2-L4) inerva a todos los componentes del cuádriceps femoral. Este nervio emerge del plexo lumbar y desciende por el triángulo femoral, donde puede comprimirse causando debilidad cuadricipital (signo del paso)."
  },
  
  {
    id: 10095,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿Qué arteria irriga principalmente al cuádriceps femoral?",
    options: [
      "Arteria femoral",
      "Arteria poplítea",
      "Arteria circunfleja femoral lateral",
      "Arteria circunfleja femoral medial"
    ],
    correctAnswer: 0,
    explanation: "La arteria femoral irriga principalmente al cuádriceps femoral a través de ramas musculares directas. La arteria femoral profunda proporciona irrigación adicional a través de las arterias circunflejas femorales lateral y medial."
  },
  
  {
    id: 10096,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué estructura se encuentra profunda al recto femoral?",
    options: [
      "Vasto intermedio",
      "Vasto lateral",
      "Iliopsoas",
      "Sartorio"
    ],
    correctAnswer: 0,
    explanation: "El vasto intermedio se encuentra profundo al recto femoral en el compartimento anterior del muslo. El recto femoral es superficial y cruza tanto la articulación de la cadera como la rodilla, mientras que el vasto intermedio es puramente monoarticular."
  },
  
  {
    id: 10097,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Qué cabeza del cuádriceps es biarticular?",
    options: [
      "Vasto medial",
      "Vasto lateral",
      "Recto femoral",
      "Vasto intermedio"
    ],
    correctAnswer: 2,
    explanation: "El recto femoral es el único músculo biarticular del cuádriceps, cruzando tanto la articulación de la cadera como la rodilla. Esto le permite actuar como flexor de cadera y extensor de rodilla. Las otras cabezas son monoarticulares (solo cruzan la rodilla)."
  },
  
  {
    id: 10098,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Dónde se origina el vasto lateral?",
    options: [
      "Línea áspera del fémur",
      "Tuberosidad glútea del fémur",
      "Trocánter mayor del fémur",
      "Cóndilo lateral del fémur"
    ],
    correctAnswer: 2,
    explanation: "El vasto lateral se origina principalmente en el trocánter mayor del fémur, además de contribuciones de la línea intertrocantérica y el labio lateral de la línea áspera. Es el más lateral y superficial de los vastos."
  },
  
  {
    id: 10099,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Qué función tiene el vasto medial en la estabilidad de la rótula?",
    options: [
      "Abduce la rótula",
      "Adduce la rótula",
      "Rota la rótula",
      "No afecta la rótula"
    ],
    correctAnswer: 1,
    explanation: "El vasto medial es crucial para la estabilidad medial de la rótula. Su contracción dinámica previene la subluxación lateral de la rótula durante la flexión-extensión de la rodilla. La atrofia del vasto medial se asocia con condromalacia rotuliana."
  },
  
  {
    id: 10100,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Por qué el cuádriceps es importante para la marcha?",
    options: [
      "Por su función de flexión",
      "Por su función de extensión",
      "Por su función estabilizadora",
      "Por su función estética"
    ],
    correctAnswer: 1,
    explanation: "El cuádriceps femoral es esencial para la marcha porque controla la extensión de la rodilla durante la fase de apoyo (stance phase). Sin un cuádriceps funcional, la rodilla colapsaría durante la carga, resultando en una marcha inestable o imposibilitando la deambulación."
  },
  
  // ========== NIVEL GENERAL (10) ==========
  
  {
    id: 10101,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Cómo contribuye el recto femoral a la marcha?",
    options: [
      "Solo como extensor de rodilla",
      "Como flexor de cadera y extensor de rodilla",
      "Solo como flexor de cadera",
      "Como extensor de cadera"
    ],
    correctAnswer: 1,
    explanation: "El recto femoral actúa como flexor de cadera durante el balanceo (swing phase) y como extensor de rodilla durante el apoyo (stance phase). Esta acción biarticular es crucial para el control de la extremidad inferior durante la marcha."
  },
  
  {
    id: 10102,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué músculos actúan como antagonistas del cuádriceps femoral?",
    options: [
      "Isquiotibiales",
      "Gastrocnemio",
      "Tibial anterior",
      "Todos los anteriores"
    ],
    correctAnswer: 0,
    explanation: "Los isquiotibiales (bíceps femoral, semitendinoso, semimembranoso) son los antagonistas primarios del cuádriceps femoral en la articulación de la rodilla. El equilibrio entre estos grupos musculares es esencial para la estabilidad articular."
  },
  
  {
    id: 10103,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿Qué rama específica irriga al vasto medial?",
    options: [
      "Arteria femoral superficial",
      "Arteria descendente genicular",
      "Arteria circunfleja femoral medial",
      "Arteria femoral profunda"
    ],
    correctAnswer: 1,
    explanation: "La arteria descendente genicular, rama de la arteria femoral, irriga específicamente el vasto medial. Esta arteria desciende por la cara medial del muslo y anastomosada con ramas de la arteria poplítea, formando una red vascular importante para la rodilla."
  },
  
  {
    id: 10104,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.INERVACION,
    question: "¿Cómo se distribuyen las raíces nerviosas en el cuádriceps?",
    options: [
      "Recto femoral: L2-L3, vastos: L3-L4",
      "Recto femoral: L3-L4, vastos: L2-L3",
      "Todos por L2-L4 uniformemente",
      "Recto femoral: L4-L5, vastos: L2-L3"
    ],
    correctAnswer: 0,
    explanation: "El recto femoral recibe inervación de L2-L3, mientras que los vastos (medial, lateral, intermedio) son inervados por L3-L4. Esta distribución explica por qué lesiones del nervio femoral en diferentes niveles pueden afectar selectivamente componentes del cuádriceps."
  },
  
  {
    id: 10105,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VARIANTE,
    question: "¿Cuál es la variante anatómica más común del cuádriceps femoral?",
    options: [
      "Ausencia del vasto medial",
      "Cabeza accesoria del recto femoral",
      "Fusión de vastos",
      "Inserción doble del tendón"
    ],
    correctAnswer: 1,
    explanation: "La presencia de una cabeza accesoria del recto femoral es la variante más común, ocurriendo en 20-30% de la población. Esta cabeza adicional se origina del acetábulo o cabeza femoral y se une al recto femoral principal, aumentando su fuerza de flexión de cadera."
  },
  
  {
    id: 10106,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "¿Qué test evalúa la integridad del cuádriceps femoral?",
    options: [
      "Test de Lachman",
      "Test de extensión resistida de rodilla",
      "Test de McMurray",
      "Test de Apley"
    ],
    correctAnswer: 1,
    explanation: "El test de extensión resistida de rodilla evalúa la fuerza del cuádriceps. El paciente extiende la rodilla contra resistencia desde flexión de 90°. Debilidad indica lesión del músculo o nervio femoral. Es más sensible que pruebas pasivas."
  },
  
  {
    id: 10107,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.EMBRIOLOGIA,
    question: "¿De qué masa muscular embrionaria se desarrolla el cuádriceps femoral?",
    options: [
      "Masa flexora ventral",
      "Masa extensora dorsal",
      "Masa deltoidea dorsal",
      "Masa aductora medial"
    ],
    correctAnswer: 1,
    explanation: "El cuádriceps femoral se desarrolla de la masa muscular extensora dorsal del miembro inferior, alrededor de la 6-7 semana de gestación. Esta masa da origen también al tibial anterior y extensor largo de los dedos, explicando su inervación común por el nervio femoral."
  },
  
  {
    id: 10108,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.HISTOLOGIA,
    question: "¿Qué proporción de fibras musculares tiene el cuádriceps femoral?",
    options: [
      "80% fibras tipo I",
      "60% fibras tipo II",
      "50% tipo I, 50% tipo II",
      "70% tipo I, 30% tipo II"
    ],
    correctAnswer: 2,
    explanation: "El cuádriceps femoral tiene distribución equilibrada de fibras musculares (50% tipo I, 50% tipo II), adaptado para movimientos de fuerza y resistencia. El vasto medial tiene ligeramente más fibras tipo I, contribuyendo a su rol estabilizador de la rótula."
  },
  
  {
    id: 10109,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué estructura fascial envuelve al cuádriceps femoral?",
    options: [
      "Fascia lata",
      "Fascia femoral",
      "Septos intermusculares",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "El cuádriceps femoral está envuelto por la fascia femoral profunda y limitado por septos intermusculares (medial y lateral) que lo separan del compartimento aductor medialmente y los isquiotibiales posteriormente. La fascia lata es más superficial."
  },
  
  {
    id: 10110,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Por qué el cuádriceps es crucial en la prevención de caídas?",
    options: [
      "Por su función estética",
      "Por su función de extensión de rodilla",
      "Por su función de absorción de impacto",
      "Por su función de propulsión"
    ],
    correctAnswer: 1,
    explanation: "El cuádriceps femoral es crucial para prevenir caídas porque controla la extensión de la rodilla durante la fase de apoyo de la marcha. La debilidad cuadricipital (como en personas mayores) aumenta significativamente el riesgo de caídas por colapso de la rodilla."
  },
  
  // ========== NIVEL COMPLEJO (10) ==========
  
  {
    id: 10111,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente con antecedente de artroplastia de cadera presenta debilidad cuadricipital progresiva. EMG muestra denervación. ¿Qué complicación sugiere?",
    options: [
      "Lesión del nervio femoral",
      "Compresión del nervio ciático",
      "Lesión del nervio peroneo",
      "Síndrome compartimental"
    ],
    correctAnswer: 0,
    explanation: "La lesión del nervio femoral es una complicación reconocida de artroplastias de cadera, especialmente por estiramiento o compresión durante la cirugía. Causa debilidad cuadricipital (dificultad para extender rodilla y subir escaleras) y pérdida del reflejo rotuliano. La recuperación puede tomar 6-12 meses."
  },
  
  {
    id: 10112,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Paciente con dolor anterior de rodilla y atrofia selectiva del vasto medial. ¿Qué patología sugiere?",
    options: [
      "Condromalacia rotuliana",
      "Tendinitis patelar",
      "Síndrome de la cintilla iliotibial",
      "Menisco roto"
    ],
    correctAnswer: 0,
    explanation: "La atrofia selectiva del vasto medial sugiere condromalacia rotuliana crónica. El vasto medial es el principal estabilizador dinámico medial de la rótula. Su inhibición refleja por dolor crónico lleva a atrofia desproporcionada. La rehabilitación debe enfocarse en fortalecimiento específico del vasto medial."
  },
  
  {
    id: 10113,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Qué técnica se utiliza para reparar una ruptura completa del tendón cuadricipital?",
    options: [
      "Sutura directa con refuerzo",
      "Reconstrucción con autoinjerto",
      "Transferencia tendinosa",
      "Artrodesis de rodilla"
    ],
    correctAnswer: 0,
    explanation: "La ruptura completa del tendón cuadricipital se repara con sutura directa reforzada con cintas de sutura o anclas óseas. La reparación temprana (<2 semanas) tiene mejor pronóstico. Las rupturas crónicas pueden requerir avance tendinoso o reconstrucción con aloinjerto de Aquiles."
  },
  
  {
    id: 10114,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En RM de muslo, ¿qué hallazgo confirma ruptura parcial del vasto intermedio?",
    options: [
      "Engrosamiento difuso",
      "Señal hiperintensa en T2 con disrupción fibrilar",
      "Atrofia global",
      "Calcificaciones intratendinosas"
    ],
    correctAnswer: 1,
    explanation: "La ruptura parcial del vasto intermedio muestra señal hiperintensa en T2-STIR con disrupción parcial de las fibras musculares. Es menos común que rupturas de otros vastos debido a su posición profunda. La ecografía puede mostrar hematoma intramuscular. La recuperación requiere inmovilización prolongada."
  },
  
  {
    id: 10115,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "¿Qué complicación puede causar la atrofia del cuádriceps post-inmovilización prolongada?",
    options: [
      "Hipertrofia compensatoria",
      "Artropatía de rodilla",
      "Mejoría de la estabilidad",
      "Aumento de la fuerza"
    ],
    correctAnswer: 1,
    explanation: "La atrofia cuadricipital post-inmovilización (como enyesado prolongado) puede causar artropatía de rodilla por alteración de la biomecánica articular. El cuádriceps atrofiado no proporciona compresión articular adecuada, llevando a cambios degenerativos. La rehabilitación agresiva es crucial para prevenir secuelas permanentes."
  },
  
  {
    id: 10116,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente diabético con dolor de muslo anterior y debilidad cuadricipital. ¿Qué complicación metabólica sugiere?",
    options: [
      "Cetoacidosis diabética",
      "Necrosis cuadricipital diabética",
      "Rabdomiólisis",
      "Miopatía diabética"
    ],
    correctAnswer: 1,
    explanation: "La necrosis cuadricipital diabética es una complicación rara pero grave de diabetes mellitus de larga evolución. Se presenta con dolor intenso de muslo anterior y debilidad cuadricipital. La RM muestra edema difuso y necrosis. Se trata con control metabólico estricto y rehabilitación gradual."
  },
  
  {
    id: 10117,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Evaluación isocinética muestra déficit selectivo de extensión excéntrica de rodilla. ¿Qué componente del cuádriceps está afectado?",
    options: [
      "Recto femoral",
      "Vasto medial",
      "Vasto lateral",
      "Vasto intermedio"
    ],
    correctAnswer: 1,
    explanation: "El vasto medial es más activo en contracciones excéntricas durante la extensión de rodilla, actuando como freno durante la flexión rápida. Su debilidad selectiva se asocia con inestabilidad rotuliana lateral. La evaluación isocinética permite cuantificar déficits específicos de contracción concéntrica vs excéntrica."
  },
  
  {
    id: 10118,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Qué abordaje se prefiere para biopsia del cuádriceps femoral?",
    options: [
      "Abordaje lateral vasto lateral",
      "Abordaje medial vasto medial",
      "Abordaje anterior recto femoral",
      "Abordaje posterior vasto intermedio"
    ],
    correctAnswer: 0,
    explanation: "El abordaje lateral al vasto lateral es preferido para biopsia del cuádriceps porque evita estructuras vasculonerviosas importantes (arteria femoral y nervio femoral medialmente). Permite acceso al vasto lateral, que es fácilmente palpable y tiene buena representación histológica."
  },
  
  {
    id: 10119,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En ecografía dinámica de rodilla, ¿qué maniobra evalúa la función del cuádriceps?",
    options: [
      "Extensión resistida de rodilla",
      "Flexión pasiva de rodilla",
      "Compresión rotuliana",
      "Movimiento de deslizamiento"
    ],
    correctAnswer: 0,
    explanation: "La extensión resistida de rodilla durante ecografía evalúa la función dinámica del cuádriceps. Permite visualizar la contractilidad muscular, detectar rupturas parciales no evidentes en reposo, y cuantificar atrofia. Es especialmente útil en pacientes con dolor que limita evaluación manual."
  },
  
  {
    id: 10120,
    muscle: 'cuadriceps_femoral',
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "Atleta con hipertrofia compensatoria del cuádriceps post-lesión de isquiotibiales. ¿Qué explica este hallazgo?",
    options: [
      "Adaptación neural",
      "Hipertrofia por sobrecarga",
      "Efecto Saunders",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "La hipertrofia compensatoria del cuádriceps post-lesión de isquiotibiales se explica por: 1) Adaptación neural (aumento de reclutamiento neuronal), 2) Hipertrofia por sobrecarga (cuádriceps compensa debilidad isquiotibial), 3) Efecto Saunders (inhibición refleja cruzada). La rehabilitación debe incluir fortalecimiento equilibrado."
  }
];
